import * as modules from "./modules/";
import config from "../../../../config";
const { vendor } = config;

const NoAccessDisclaimer = modules[vendor]
  ? modules[vendor]
  : modules["default"];

export default NoAccessDisclaimer;
